import styled, { css } from 'styled-components'

import { Color } from 'root-constants'

export const FlowTitle = styled.h2<{ isAlignedLeft?: boolean }>`
  color: ${Color.BLACK};
  font-family: 'Lora', serif;
  font-size: 28px;
  font-weight: 600;
  line-height: 36px;
  text-align: ${({ isAlignedLeft }) => (isAlignedLeft ? 'start' : 'center')};
`

export const FlowDescription = styled.p`
  color: ${Color.GRAY};
  font-family: 'Open Sans', sans-serif;
  font-size: 17px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
`

export const FlowContent = styled.div`
  max-width: 390px;
  margin: 0 auto;
  padding: 24px 16px 0;
`

export const FlowOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const FlowBottomArea = styled.div<{ isFixed?: boolean }>`
  width: 100%;
  max-width: 390px;
  margin: 0 auto;
  padding: 16px;

  ${({ isFixed }) =>
    isFixed &&
    css`
      position: fixed;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0) 0%,
        ${Color.WHITE} 40%
      );
    `}
`

export const FlowOutcomeTitle = styled(FlowTitle)`
  margin-bottom: 48px;
`
